import { createContext } from 'react';

interface IToastContext{
    toasterId: string;
    notifyError: (errorMsg: string) => void;
    notifySuccess: (successMessage: string) =>void;
    notifySaveSuccess: (successMessage: string) =>void;
}

export const ToastContext = createContext<IToastContext>({
    toasterId: '',
    notifyError: ()=>{},
    notifySuccess: ()=>{},
    notifySaveSuccess: ()=>{} 
});